import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {MaterialStorage} from '../types'

export const SiloFillLevelsQueryKey = 'silo-fill-levels'

type Params = {
  plantId: string
  snapshotDateTime: string
  options?: Omit<UseQueryOptions<MaterialStorage[], AxiosError>, 'queryKey'>
}

export const useSiloFillLevels = ({plantId, snapshotDateTime, options}: Params) =>
  useQuery<MaterialStorage[], AxiosError>({
    queryKey: [SiloFillLevelsQueryKey, snapshotDateTime, plantId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<MaterialStorage[]>(
        `/shifthandover/${plantId}/siloFillLevels`,
        {params: {to: snapshotDateTime}, signal}
      )
      return response?.data || []
    },
    ...options
  })
